var _path, _path2;
var _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgLogoEliteConvIcon = function SvgLogoEliteConvIcon(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7022 28.4633C20.7022 28.4633 0.569652 27.7465 0.012329 39.6871C-0.00220988 39.9934 0.244951 40.2483 0.550266 40.2483H27.5425C27.8311 40.2483 28.1095 40.2035 28.3706 40.1208L34.8587 28.4628H20.7022V28.4633Z",
    fill: "#FFF6F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9705 0.65081C28.5462 0.387745 28.0567 0.25 27.5587 0.25H0.538476C0.241237 0.25 0 0.491999 0 0.790176V14.4539C0 14.6862 0.148619 14.8915 0.367779 14.966C10.9327 18.5436 20.2225 25.3714 25.8813 35.2852C26.7649 36.8334 27.5608 38.4572 28.2587 40.1555C28.5075 40.0885 28.7422 39.9875 28.9576 39.8578C28.9765 39.8459 28.9953 39.8341 29.0142 39.8222C35.5329 35.7611 39.8741 28.5147 39.8741 20.2505C39.8741 11.9864 35.5141 4.70645 28.9705 0.65081Z",
    fill: "#FF2E00"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoEliteConvIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-elite-conv-icon.73560db9.svg";
export { ForwardRef as ReactComponent };